import React, { Component } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
import moment from 'moment';
import { connect } from 'react-redux';
import { fetchUploadTransactions } from 'ducks/uploadTransactions';
import { fetchEntityDefinitions } from 'ducks/entityDefinitions';
import { fetchProjects } from 'ducks/projects';
import { onDeleteComplete } from 'ducks/details';
import { setMessage } from 'ducks/message';
import TopNavigation from 'components/TopNavigation';
import NavigationBar from 'components/NavigationBar';

import Column from 'components/UIKit/Flex/Column';
import { Outlet } from 'react-router';
import withRouting from '../utils/withRouting';

class ProjectHandler extends Component {
  static propTypes = {
    children: PropTypes.any,
    location: PropTypes.any,
    params: PropTypes.any
  };

  componentDidMount() {
    let { dispatch, projects, history } = this.props;
    const { program, project } = this.props.router.params;
    let projectId = `${program}-${project}`;
    this.validateProject({ projectId, projects, history, dispatch });

    dispatch(fetchEntityDefinitions({ program, project }));

    this.getTransactions(this.props);
    this.setState({ pollingId: setInterval(() => this.getTransactions(this.props), 15 * 1000) }); // 15" polling frequency
  }

  componentDidUpdate() {
    let {
      data, dispatch, otherTransactions, projects,
    history
    } = this.props;
    const { program, project } = this.props.router.params;

    let projectId = `${program}-${project}`;
    this.validateProject({ projectId, projects, history, dispatch });
    this.checkForNewUploadTransactions({ data, dispatch });
    this.checkForNewSubmission({ data: otherTransactions, dispatch, projects });
    this.checkForNewDeletion({ data: otherTransactions, dispatch });
  }

  componentWillUnmount() {
    clearInterval(this.state.pollingId);
  }

  getTransactions(props): void {
    let { params } = props.router;
    let { program, project } = params;
    props.dispatch(fetchUploadTransactions({
      first: 10,
      offset: 0,
      sort: 'created_datetime',
      order: 'desc',
      program,
      project,
    }));
  }

  validateProject = ({ projectId, projects, history, dispatch }) => {
    if (projects.items.length) {
      if (projects.items.some(p => p.project_id === projectId)) {
        // Project exists, do nothing
      } else {
        // Project doesn't exist, redirect to projects page and dispatch notification
        history.replaceState(null, '/');
        dispatch(setMessage('The project you have entered does not exist'));
      }
    }
  };

  checkForNewSubmission({ dispatch, data, projects }) {
    if (data.items && data.items.length) {
      const { items } = data;

      const nextTransaction = items[0];
      let txMoment = moment(nextTransaction.created_datetime);
      let isIncoming = moment().subtract(2, 'seconds').isBefore(txMoment);

      if (isIncoming && nextTransaction.type === 'submit' && nextTransaction.state === 'SUCCEEDED') {
        dispatch(fetchProjects({ ids: projects.items.map(x => x.project_id) }));
      }
    }
  }

  checkForNewUploadTransactions({ dispatch, data }) {
    if (data.items && data.items.length) {
      const { items } = data;

      const nextTransaction = items[0];
      let txMoment = moment(nextTransaction.created_datetime);
      let isIncoming = moment().subtract(2, 'seconds').isBefore(txMoment);

      if (isIncoming && nextTransaction.state !== 'PENDING') {
        dispatch(setMessage(
          nextTransaction.state === 'SUCCEEDED'
            ? `A transaction has finished ${nextTransaction.is_dry_run ? 'validating' : 'uploading'}.`
            : `A transaction has failed ${nextTransaction.is_dry_run ? 'validating' : 'uploading'}`
        ));
      }
    }
  }

  checkForNewDeletion({ dispatch, data }) {
    dispatch(onDeleteComplete(data.items));
  }

  render(): React.Element {
    let { projects } = this.props;
    const { location, params } = this.props.router;
    let projectId = `${params.program}-${params.project}`;

    return (
      <Column style={{flex: 1}}>
        <NavigationBar {...this.props} />
        <TopNavigation
          location={location}
          project={projects.items.filter(p => p.project_id === projectId)[0] || {}}
        />
        <Outlet />
      </Column>
    );
  }
}

export default connect(({
  projects,
  uploadTransactions: { data, otherTransactions }
}) => ({
  projects,
  data,
  otherTransactions,
}))(withRouting(ProjectHandler));
